import { createSlice } from "@reduxjs/toolkit";
import {     reKyc_EsignRequestThunk } from "./thunk";

export const initialState = {
  reKyc_EsignRequestData: [],
  reKyc_EsignRequestError: '', // for error message
  reKyc_EsignRequestLoading: false,
};

const Re_Kyc_Esign_Request = createSlice({
  name: "Re_Kyc_Esign_Request",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(reKyc_EsignRequestThunk.pending, (state) => {
      state.reKyc_EsignRequestLoading = true ;
      state.reKyc_EsignRequestData= [];
      state.reKyc_EsignRequestError='';

  });
    builder.addCase(reKyc_EsignRequestThunk.fulfilled, (state, action) => {
        state.reKyc_EsignRequestData = action.payload.data;
        state.reKyc_EsignRequestLoading = false ;
    });
    builder.addCase(reKyc_EsignRequestThunk.rejected, (state, action) => {
      state.reKyc_EsignRequestError = action.error?.message || action.payload?.message || "An unknown error occurred";
        state.reKyc_EsignRequestLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  
  
} = Re_Kyc_Esign_Request.actions

export default Re_Kyc_Esign_Request.reducer;